import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=f87d551e&scoped=true&"
import script from "./CategoryFilters.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=f87d551e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87d551e",
  null
  
)

export default component.exports